module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Icono-7.d9b33171.svg";